export default __webpack_public_path__ + "static/media/cor-new.6f27372f.svg";